export default __webpack_public_path__ + "static/media/ndsp-logo.e464cb3f.png";